import { normalizeUsername } from '../../hooks/useMemberPerformanceProfile';

export const ACCESS = {
  SIGNED_OUT: 'signed_out',
  // A signed-in member viewing another member's page: the opt-in shared view.
  VIEWER: 'viewer',
  ALLOWED: 'allowed',
};

// The owner gets their own page. Any other signed-in member gets the shared view (the server
// decides whether that member has shared). Signed-out visitors are asked to sign in.
export const getPerformanceAccess = (loggedInUser, routeUsername) => {
  if (!normalizeUsername(loggedInUser?.username)) {
    return ACCESS.SIGNED_OUT;
  }
  return normalizeUsername(loggedInUser.username) === normalizeUsername(routeUsername)
    ? ACCESS.ALLOWED
    : ACCESS.VIEWER;
};
